import { useField } from "formik";

import { Picker, PickerProps } from "../components/picker/Picker";
import { PickerItem } from "../components/picker/types";

export interface PickerFormikFieldProps<T extends PickerItem>
  extends PickerProps<T> {
  name: string;
  label: PickerProps<T>["label"];
  items?: PickerProps<T>["items"];
  children?: PickerProps<T>["children"];
  onSelectionChange?: PickerProps<T>["onSelectionChange"];
  testID: string;
  className?: string;
  trigger?: PickerProps<T>["trigger"];
  selectionMode?: PickerProps<T>["selectionMode"];
  default?: string;
}

export function PickerFormikField<T extends PickerItem>(
  props: PickerFormikFieldProps<T>
) {
  const [field, , helpers] = useField(props.name);

  return (
    <Picker
      {...props}
      selectedKeys={field.value ?? props.default ?? []}
      onSelectionChange={(value) => {
        helpers.setValue(value);
        props.onSelectionChange?.(value);
      }}
      onBlur={() => {
        helpers.setTouched(true);
      }}
    />
  );
}
